<div class="p-p-2">
  <span class="p-float-label">
    <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="value" (onTouched)="onTouched()"
      (ngModelChange)="onChange()" [disabled]="disabled" style="width: 100%;"></textarea>
    <label>{{label|translate}}</label>
  </span>
</div>
